import React from 'react';
import PropTypes from 'prop-types';
import ReactHelmet from 'react-helmet';
import { always, ifElse, isNil, path, pipe } from 'ramda';
import { getSocialImage } from '../../utils/contentfulImages';

const getSocialImageFromAssets = (id, assets, defaultUrl = '') =>
  pipe(
    path([id, 'file', 'url']),
    ifElse(isNil, always(defaultUrl), getSocialImage)
  )(assets);

export const Helmet = ({ reactHelmetProps, imageAssetId, assets, websiteConfig, noTitle, ...props }) => {
  const { shareTitle, shareDescription, shareImage } = websiteConfig;

  const defaultImageUrl = getSocialImageFromAssets(shareImage, assets);
  const imageUrl = getSocialImageFromAssets(imageAssetId, assets, defaultImageUrl);

  const title = props.title || shareTitle;
  const description = props.description || shareDescription;

  return (
    <ReactHelmet title={noTitle ? undefined : title} {...reactHelmetProps}>
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />

      <meta property="twitter:card" content="summary" />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />

      <meta property="og:image" content={imageUrl} />
      <meta property="twitter:image" content={imageUrl} />
    </ReactHelmet>
  );
};

Helmet.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  imageAssetId: PropTypes.string,
  assets: PropTypes.object.isRequired,
  reactHelmetProps: PropTypes.object,
  websiteConfig: PropTypes.object,
  noTitle: PropTypes.bool,
};

Helmet.defaultProps = {
  websiteConfig: {},
};
